export const formatCurrency = (val) =>
  val.toLocaleString("en-NG", {
    style: "currency",
    currency: "NGN",
  });
